import { get } from '../../../../../../../infra/rest';
import { CustomFieldFilterMetadata } from '../typings';

export const getCustomFieldFilterMetadata = async (): Promise<CustomFieldFilterMetadata> => {
  return get<CustomFieldFilterMetadata>('/v4/search/filter-metadata', {}, true);
};
